import { render, staticRenderFns } from "./ChecklistList.vue?vue&type=template&id=4568d547"
import script from "./ChecklistList.vue?vue&type=script&lang=js"
export * from "./ChecklistList.vue?vue&type=script&lang=js"
import style0 from "./ChecklistList.vue?vue&type=style&index=0&id=4568d547&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports